module.exports = {
  langKey: 'en',
  'selectLanguage': 'English',
  'sk': 'Slovensky',
  'en': 'English'
};
